<template>
    <div id="seccion-principal-firma-multiple" class="container-fluid">
        <div id="encabezados-tp">
            <h1>Firma electrónica múltiple</h1>
            <h3>Firma de documentos</h3>
            <div class="hr-titulo"></div>
        </div>
        <div class="d-flex flex-wrap" style="gap: 2em !important; margin-top:3em;">
            <div class="form-group">
                <div class="paso-formulario-modal" style="width: max-content; background-color: #323335;">
                    <h6 class="form-inline"><strong><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Tipos de estatus</strong></h6>
                    <hr style="border: 1px solid rgb(82, 81, 81); margin-top: 0;">
                    <div class="form-inline flex-wrap mt-3" style="gap: 1.5em !important;">
                        <h6 class="form-inline" style="gap: 0.5em !important;">Firmado por todos:<i class="fas fa-square" style="color: rgb(147, 158, 145);"></i></h6>
                        <h6 class="form-inline" style="gap: 0.5em !important;">Firmado por ti:<i class="fas fa-square" style="color: rgb(163, 147, 91);"></i></h6>
                        <h6 class="form-inline" style="gap: 0.5em !important;">Sin firma:<i class="fas fa-square" style="color: #E9ECEF;"></i></h6>
                    </div>
                </div>
            </div>
            <div class="align-self-end col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-0 pt-0 pb-0 pl-0">
                <h6>Mostrar solicitudes</h6>
                <CCatalogoGenerico class="p-0 m-0" 
                    v-on:valorParaElPadre="evtCambioTipoFiltroEstatus" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="CtipoDeEstatusSolicitud.ID" 
                    :valorDefinido="CtipoDeEstatusSolicitud.valorDefinido"
                    :textoOpcionesSingular="''"
                    :textoOpcionesPlural="''"
                    :elementosCatalogo="CtipoDeEstatusSolicitud.opciones"
                    :conOpcionDeinstrucciones="CtipoDeEstatusSolicitud.mostrarSoloOpcionesValidas"
                    :key="CtipoDeEstatusSolicitud.KEY + CtipoDeEstatusSolicitud.contRender"></CCatalogoGenerico>
            </div>
        </div>
        <!-- SECCION PRINCIPAL FORMULARIO -->
        <div class="row mt-4">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-2">
                <div class="card">
                    <div class="card-header">
                        <div class="form-inline justify-content-between flex-wrap">
                            <h5 class="form-inline">
                                <strong>PENDIENTES DE FIRMAR</strong>&nbsp;&nbsp;
                                <span class="badge bg-primary rounded-pill">{{ getNumeroDePendientes }}</span>
                            </h5>
                        </div>
                    </div>
                    <div class="card-body" style="padding: 1em 2em 0 2em !important;">
                        <div class="tabla-firma-multiple-VFDD">
                            <div id="toolbar-tabla-pendientes-firmar">
                                <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                                    <button @click="cargarInformacionDeSolicitudes({ conLoading: true })" v-tooltip:left="'Actualizar tabla desde base de datos'" type="button" class="btn btn-sm btn-encabezado btn-info"><i class="fas fa-sync"></i></button>
                                    <button type="button" @click="mostrarFormularioCreacionSolicitud" class="btn btn-sm btn-encabezado btn-info"><i class="fas fa-plus"></i>&nbsp;&nbsp;Nueva solicitud</button>
                                    <button v-if="mostrarOpcionFirmar" @click="mostrarModalFormularioFirmar" type="button" class="btn btn-sm btn-firmantes-VFDD"><i class="fas fa-file-signature"></i>&nbsp;&nbsp;Firmar <strong>{{ `(${ getNumeroDePendientesParaFirmar })` }}</strong></button>
                                </div>
                            </div>
                            <table
                                class="table table-striped table-light table-hover"
                                :id="pendientesDeFirmar.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-toolbar="#toolbar-tabla-pendientes-firmar"
                                data-undefined-text="Sin información" 
                                data-maintain-meta-data="true"
                                data-click-to-select="true"
                                data-page-size = "100"
                                data-page-list="[200,300,400,500]"
                                data-show-toggle="true"
                                data-show-pagination-switch="true"
                                data-row-style="aplicarEstilosEstatusEnFilas"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="6" data-align="center" data-field="seleccionado" data-formatter="deshabilitacioSolicitudesFormatter"  data-checkbox="true"></th>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="multifirmaId" data-sortable="true">
                                            Id
                                        </th>
                                        <th data-halign="center" data-width="38" data-align="center" data-field="descripcion" data-sortable="true">
                                            Descripción
                                        </th>
                                        <th data-halign="center" data-width="15" data-align="center" data-field="fechaDeSolicitud" data-sortable="true">
                                            Creación
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="numeroFirmantes" data-sortable="true">
                                            Firmantes
                                        </th>
                                        <th data-halign="center" data-width="6" data-align="center" data-events="operateEvents" data-field="documento" data-sortable="true">
                                            Doc
                                        </th>
                                        <th data-halign="center" data-width="15" data-align="center" data-field="estatusSTR" data-sortable="true">
                                            Firmado
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-mostrar-seccion-firmar-VFDD">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>
                                La solicitud de firma se creo y se guardo de manera correcta,<br>
                                ¿Deseas agregar tu firma en este momento?
                            </h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="mostrarSeccionParaFirmarDocumento"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="cerrarModalConfirmacion({ referencia: 'modal-mostrar-seccion-firmar-VFDD' })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL SECCION CREACION SOLICITU DE FIRMA -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-creacion-solicitud-VFDD">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Creación solicitud firma de documento</h5>
                        <button  id="btn-cerrar-modal-creacion-solicitud-VFDD" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4 paso-principal-creacion-solicitud">
                        <div v-if="!formularioSolicitud.verDocumentoSIOP && formularioSolicitud.verUsuariosSeleccionados">
                            <div class="d-flex mb-3">
                                <button type="button" @click="formularioSolicitud.verUsuariosSeleccionados = false" class="btn btn-sm btn-danger"><i class="fas fa-chevron-circle-left"></i>&nbsp;&nbsp;Regresar a formulario</button>
                            </div>
                            <div class="paso-formulario-modal">
                                <div class="tabla-firma-multiple-VFDD">
                                    <div id="toolbar-tabla-lista-usuariosSeleccionados">
                                        <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                                            <h6 class="form-inline"><strong>Usuarios seleccionados para firmar</strong></h6>
                                        </div>
                                    </div>
                                    <table
                                        class="table table-striped table-light table-hover"
                                        :id="formularioSolicitud.tablaUsuariosSeleccionados.ID"  
                                        data-toggle="table"
                                        data-search-align="right"
                                        data-pagination="true"
                                        data-toolbar="#toolbar-tabla-lista-usuariosSeleccionados" 
                                        data-toolbar-align="left"
                                        data-undefined-text="Sin información" 
                                        data-maintain-meta-data="true"
                                        data-click-to-select="true"
                                        data-page-size = "10"
                                        data-page-list="[2, 5, 15,20,30]"
                                        data-show-toggle="false"
                                        data-show-pagination-switch="false"
                                        data-search="true">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th data-halign="center" data-width="20" data-align="center" data-field="IdUsuario" data-sortable="true">
                                                    Id
                                                </th>
                                                <th data-halign="center" data-width="70" data-align="center" data-field="Nombre" data-sortable="true">
                                                    Nombre
                                                </th>
                                                <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="accionRemover" data-sortable="true"></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-if="formularioSolicitud.verDocumentoSIOP && !formularioSolicitud.verUsuariosSeleccionados" id="seccion-ver-documento-SIOP">
                            <div class="d-flex justify-content-end mb-3">
                                <button type="button" @click="formularioSolicitud.verDocumentoSIOP = false" class="btn btn-sm btn-danger"><i class="fas fa-save"></i>&nbsp;&nbsp;Cerrar documento</button>
                            </div>
                            <PDFDocument
                                :url="formularioSolicitud.visorDeDocumento.url" 
                                :ArchivoAConvertir="formularioSolicitud.visorDeDocumento.archivo"
                                :height="formularioSolicitud.visorDeDocumento.height"
                                :key="formularioSolicitud.visorDeDocumento.KEY + formularioSolicitud.visorDeDocumento.contRender" />
                        </div>
                         <div v-if="!formularioSolicitud.verDocumentoSIOP && !formularioSolicitud.verUsuariosSeleccionados">
                          <!--  <h6 v-if="MAJAT.usuarioRegistrado" class="form-inline" style="font-size: 1.5em !important; font-weight: bold;">
                                <i  @click="formularioSolicitud.esDocumentoDeBaseDeDatos = !formularioSolicitud.esDocumentoDeBaseDeDatos"
                                    style="cursor: pointer;"
                                    :class="[(!formularioSolicitud.esDocumentoDeBaseDeDatos) ? 'far fa-square' : 'fas fa-check-square']"></i>&nbsp;&nbsp;
                                Acuerdo ya fue registrado en Majat?
                            </h6>-->
                           
                           <div>
                                <div class="d-flex justify-content-end">
                                    <button v-if="mostrarOpcionGuardarSolicitud" type="button" @click="ejecutarProcesoCreacionDeSolicitud" class="btn btn-save-solicitud btn-encabezado btn-info"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                </div>
                                <h6 class="text-warning">* Se habilitara el boton de guardar al momento de llenar campos obligatorios.</h6>
                           </div>
                        </div> 
                        <div v-show="!formularioSolicitud.verDocumentoSIOP && !formularioSolicitud.verUsuariosSeleccionados" id="paso-creacion-solicitud" class="mt-3 paso-formulario-modal">
                            <!-- <div class="form-group">
                                <h6 class="form-inline">
                                    <i :class="[(!this.campoEsValido(formularioSolicitud.descripcion)) ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                    Ingresa la descripción del documento
                                </h6>
                                <textarea  v-model="formularioSolicitud.descripcion" type="text" class="form-control" placeholder="Ingrese la descripcion del documento" rows="4"/>
                            </div> 
                            <hr/> -->
                            <div class="form-group">
                                <h6 class="form-inline">
                                    <i :class="[(!documentoDeSolicitudYaFueIngresado) ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                    Selecciona el documento
                                </h6>
                                <h6 class="form-inline text-warning mt-2 pb-3" v-if="formularioSolicitud.tablaDocumentosSIOP.lista.length < 1 && formularioSolicitud.tablaDocumentosSIOP.mostrarInfoResultados">
                                    No se encontraron resultados
                                </h6>
                                <div class="row">
                                    <div v-show="formularioSolicitud.esDocumentoDeBaseDeDatos" class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-3">
                                        <div v-show="false" class="col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-4">
                                            <i>Tipo de documento</i>
                                            <CCatalogoGenerico class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoDeDocumento" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="formularioSolicitud.CtipoDeDocumento.ID" 
                                                :valorDefinido="formularioSolicitud.CtipoDeDocumento.valorDefinido"
                                                :textoOpcionesSingular="''"
                                                :textoOpcionesPlural="''"
                                                :elementosCatalogo="formularioSolicitud.CtipoDeDocumento.opciones"
                                                :conOpcionDeinstrucciones="formularioSolicitud.CtipoDeDocumento.mostrarSoloOpcionesValidas"
                                                :key="formularioSolicitud.CtipoDeDocumento.KEY + formularioSolicitud.CtipoDeDocumento.contRender"></CCatalogoGenerico>
                                        </div>
                                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 form-group filtros-imp-text-VFDD">
                                            <i>#Expediente</i>
                                            <!-- CONSECUTIVO DE DOCUMENTO -->
                                            <div class="input-group">
                                                <div class="input-group-append">
                                                    <div class="input-group-text"><i class="fa fa-folder"></i></div>
                                                </div>
                                                <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" v-model="formularioSolicitud.filtros.consecutivo" type="text" v-mask="'####/####'" placeholder="####/####">
                                            </div>
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 form-group pr-4">
                                            <i>#Folio</i>
                                            <input class="form-control input-sm input-xs input-md input-lg" v-model="formularioSolicitud.filtros.folio" type="text" v-mask="'##########'" placeholder="##########">
                                        </div>
                                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 form-group align-self-end">
                                            <button type="button" @click="ejecutarProcesoBusquedaDocumentoSIOP" class="btn btn-sm btn-light"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                        </div>
                                    </div>
                                    <!-- TABLA DE DOCUMENTOS SIOP -->
                                    <div v-show="formularioSolicitud.esDocumentoDeBaseDeDatos && formularioSolicitud.tablaDocumentosSIOP.lista.length > 0" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4">
                                        <div class="tabla-firma-multiple-VFDD">
                                            <div id="toolbar-tabla-lista-documentosSIOP">
                                                <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                                                    <i><strong>{{ getDocumentoSeleccionadoDeSIOP }}</strong></i>
                                                </div>
                                            </div>
                                            <table
                                                class="table table-striped table-light table-hover"
                                                :id="formularioSolicitud.tablaDocumentosSIOP.ID"  
                                                data-toolbar="#toolbar-tabla-lista-documentosSIOP" 
                                                data-toolbar-align="right"           
                                                data-toggle="table"
                                                data-search-align="left"
                                                data-pagination="true"
                                                data-undefined-text="Sin información" 
                                                data-maintain-meta-data="true"
                                                data-click-to-select="true"
                                                data-page-size = "2"
                                                data-page-list="[1, 2, 5,10,20,30]"
                                                data-show-toggle="false"
                                                data-show-pagination-switch="false"
                                                data-search="true">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-radio="true"></th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-click-to-select="false" data-field="folio" data-sortable="true">
                                                            folio
                                                        </th>
                                                        <th data-halign="center" data-width="70" data-align="center" data-click-to-select="false" data-field="descripcion" data-sortable="true">
                                                            descripcion
                                                        </th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-click-to-select="false" data-events="operateEvents" data-field="documentoSTR" data-sortable="true">
                                                            Doc
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-show="!formularioSolicitud.esDocumentoDeBaseDeDatos" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                       <div class="upload-container">
                                       <input type="file" id="f-solicitud-inpDocumento" class="form-control" v-on:change="evtCargarDocumentoSeleccionado($event)" :accept="formularioSolicitud.EXTENSIONES_DOCUMENTOS" multiple/>
                                        <label class="area-documento" v-for="(archivo,index) in formularioSolicitud.archivo" :key="index" style="margin-left: 1em;"> <i class="fa fa-file"  style="color: black;" aria-hidden="true"></i> &nbsp;&nbsp;{{archivo.name}}&nbsp;&nbsp;
                                        <button  class="btn btn-light" @click="eliminarDocumento(index)"><i class="fa fa-trash" style="color: red;" aria-hidden="true"></i></button></label>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div class="tabla-firma-multiple-VFDD" style="margin-top: 2em;">
                                <div class="form-inline flex-wrap justify-content-between">
                                    <h6 class="form-inline">
                                        <i :class="[(!formularioSolicitud.tablaUsuarios.lista.some(u => u.seleccionado)) ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                        Selecciona quien firma el documento
                                    </h6>
                                </div>
                                <div id="toolbar-tabla-usuarios-solicitud" class="form-inline">
                                    <div class="form-inline flex-wrap pt-2" style="gap: 0.5em !important;">
                                        <span class="badge bg-primary rounded-pill">{{ getNumeroDeFirmantesSolcitud }}</span>
                                        <i class="hover-texto" v-tooltip:top="'Ver lista de firmantes'" style="cursor: pointer;" @click="mostrarTablaUusariosSeleccionados">Seleccionados</i>
                                    </div>
                                </div>
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="formularioSolicitud.tablaUsuarios.ID"              
                                    data-toggle="table"
                                    data-toolbar="#toolbar-tabla-usuarios-solicitud"
                                    data-pagination="true"
                                    data-toolbar-align="right"
                                    data-undefined-text="Sin información" 
                                    data-maintain-meta-data="true"
                                    data-click-to-select="true"
                                    data-page-size = "2"
                                    data-page-list="[1,3,5,10,20,30]"
                                    data-show-toggle="false"
                                    data-show-pagination-switch="false"
                                    data-search="true"
                                    data-search-align="left">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="IdUsuario" data-sortable="true">
                                                Id
                                            </th>
                                            <th data-halign="center" data-width="80" data-align="center" data-field="Nombre" data-sortable="true">
                                                Nombre
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
        <!-- MODAL SECCION FIRMAR DOCUMENTO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-firma-documento-VFDD">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Firma documento</h5>
                        <button  id="btn-cerrar-modal-firma-documento-VFDD" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pr-4 pl-4 pb-4">
                        <div v-if="formularioFirma.error.activo" class="alert alert-danger" style="margin-bottom: 2em;" role="alert">
                            <h4 class="alert-heading"><strong><i class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp;Error en formulario</strong></h4>
                            <p>{{ formularioFirma.error.mensaje }}</p>
                        </div>
                        <div class="form-inline justify-content-between">
                            <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                                <span class="badge bg-primary rounded-pill">{{ getNumeroDeDocumentosAFirmar }}</span>
                                <i>Documentos seleccionados para firmar</i>
                            </div>
                            <button v-if="firmaElectronica.activarBoton && this.campoEsValido(firmaElectronica.password)" type="button" @click="ejecutarProcesoFirmaDeDocumentos" class="btn btn-sm btn-encabezado btn-info"><i class="fas fa-signature"></i>&nbsp;&nbsp;Firmar documento</button>
                        </div>
                        <div id="paso-creacion-solicitud" class="paso-formulario-modal mt-3">
                            <!-- INICIO ELIMINAR -->
                           <!--  <div class="form-group">
                                <h6 class="form-inline">
                                    <i :class="[!formularioFirma.camposIngresados.archivoDeDocumento ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                    Selecciona el archivo del documento a firmar
                                </h6>
                                <input type="file" id="f-firma-inpArchivoFirel" class="form-control" v-on:change="evtSeleccionarArchivoDeDocumento($event)" :accept="formularioSolicitud.EXTENSIONES_DOCUMENTOS" />
                            </div> -->
                            <!-- FIN ELIMINAR -->
                            <div class="form-group">
                                <h6 class="form-inline">
                                    <i :class="[!formularioFirma.camposIngresados.archivoDePfx ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                    Selecciona la llave (FIREL)
                                </h6>
                                <input type="file" id="f-firma-inpArchivoFirel" class="form-control" v-on:change="evtSeleccionDeArchivoPFX($event)" :accept="'.pfx'" />
                            </div>
                            <div class="form-group">
                                <h6 class="form-inline">
                                    <i :class="[(!this.campoEsValido(firmaElectronica.password)) ? 'far fa-square' : 'fas fa-check-square text-success']"></i>&nbsp;&nbsp;
                                    Ingresa la contraseña&nbsp;&nbsp;
                                    <i @click="formularioFirma.verContrasena = !formularioFirma.verContrasena" 
                                       :class="[(!formularioFirma.verContrasena) ? 'fas fa-eye' : 'fas fa-low-vision']"
                                       style="cursor: pointer;"></i>
                                </h6>
                                <input :type="!formularioFirma.verContrasena ? 'password' : 'text'" id="f-firma-contrasena" class="form-control" v-model="firmaElectronica.password" placeholder="contraseña" />
                            </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL SECCION INFORMACION DE FIRMANTES -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informacion-firmantes-VFDD">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">lista de firmantes</h5>
                        <button  id="btn-cerrar-modal-informacion-firmantes-VFDD" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pr-4 pl-4 pb-4">
                        <div id="paso-creacion-solicitud" class="paso-formulario-modal mt-3" style="padding-bottom: 0 !important;">
                            <div class="tabla-firma-multiple-VFDD">
                                <div id="toolbar-tabla-lista-firmantes">
                                    <div class="form-inline flex-wrap" style="gap: 0.5em !important;">
                                        <span class="badge bg-primary rounded-pill">{{ numeroDeFirmatesRestantesParaCompletarFirma }}</span>
                                        <i>Firmas restantes</i>
                                    </div>
                                </div>
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="tablaFirmantes.ID"              
                                    data-toggle="table"
                                    data-toolbar="#toolbar-tabla-lista-firmantes"
                                    data-pagination="true"
                                    data-undefined-text="Sin información" 
                                    data-maintain-meta-data="true"
                                    data-click-to-select="true"
                                    data-page-size = "8"
                                    data-page-list="[5,10,20,30]"
                                    data-show-toggle="false"
                                    data-show-pagination-switch="false"
                                    data-search="true">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="IdUsuario" data-sortable="true">
                                                Id
                                            </th>
                                            <th data-halign="center" data-width="45" data-align="center" data-field="Nombre" data-sortable="true">
                                                Nombre
                                            </th>
                                            <th data-halign="center" data-width="27" data-align="center" data-field="FechaCuandoFirmo" data-sortable="true">
                                                Fecha firma
                                            </th>
                                            <th data-halign="center" data-width="18" data-align="center" data-field="firmoSTR" data-sortable="true">
                                                firmado
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL PARA VISUALIZAR EL DOCUMENTO FRIMADO O NO FIRMADO DE LA SOLICITUD -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-documento-solicitud-VFDD">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento de solicitud</h5>
                        <button  id="btn-cerrar-modal-documento-solicitud-VFDD" @click="pendientesDeFirmar.visorDeDocumento.mostrar = false" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pr-0 pl-0 pb-0 pt-0">
                        <PDFDocument v-if="pendientesDeFirmar.visorDeDocumento.mostrar"
                            :url="pendientesDeFirmar.visorDeDocumento.url" 
                            :ArchivoAConvertir="pendientesDeFirmar.visorDeDocumento.archivo"
                            :height="pendientesDeFirmar.visorDeDocumento.height"
                            :key="pendientesDeFirmar.visorDeDocumento.KEY + pendientesDeFirmar.visorDeDocumento.contRender" />
                    </div>           
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import { elementosDeFirma, SelectFileSign, SelectPfx, OpenPfx, RemoveCMSHeader, ObtenerStringDeBase64, ObtenerHexDeBase64  } from '../FirmaMultiple/funciones/ClienteFunciones.js'
import { servicioRestPost } from '../FirmaMultiple/servicios/MultiFirmaServicio.js'
import { saveAs } from 'file-saver';
import comun from "@/../static/js/comun"
import api from '@/../static/js/api';
import '@/../static/js/rsa/jsrsasign-latest-all-min.js'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import sistemas from '@/../static/js/sistemas'
import enumeraciones from '@/../static/js/enumeraciones'
import VueMask from 'v-mask'

Vue.use(VueMask);
export default {
    components: {
        PDFDocument: PDFDocument,
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            moment,
            comun,
            SelectFileSign,
            elementosDeFirma,
            SelectPfx,
            saveAs,
            OpenPfx,
            RemoveCMSHeader,
            ObtenerStringDeBase64,
            ObtenerHexDeBase64,
            idUsuario: -1,
            materiaAreaDeUsuarioId: -1,
            MATERIAS_USUARIOS: {
                ORAL_PENAL: 4
            },
            AREAS_SIOP: [
                54, // oralidad de ags
                102 // Adolescentes
            ],
            MAJAT: {
                usuarioRegistrado: false
            },
            enumeraciones,
            CtipoDeEstatusSolicitud: {
                TIPOS: { CUALQUIERA: 1, FIRMADO_TODOS: 2, FIRMADO: 3, PENDIENTE: 4 },
                ID: 'CEstatusDeFirma_VFMDD',
                KEY: 'KEY_EstatusDeFirma_VFMDD',
                valorDefinido: 1,
                opciones: [ { llave: 1, valor: 'Con todos los estatus' }, { llave: 2, valor: 'Sólo con estatus firmado por todos' }, { llave: 3, valor: 'Sólo con estatus firmado por ti' }, { llave: 4, valor: 'Sólo con estatus sin firma' } ],
                mostrarSoloOpcionesValidas: false,
                contRender: 0,
                seleccionado: { llave: 1, valor: 'Mostrar con todos los estatus' }
            },
            formularioSolicitud: {
                EXTENSIONES_DOCUMENTOS: '.PDF, .DOC, .DOCX',
                descripcion: 'Archivo a firmar de manera electronica',
                archivo: [],
                tablaUsuarios: {
                    ID: 'TUsuarioFirmaMultiple_VFMDD',
                    listaDB: [],
                    lista: []
                },
                verUsuariosSeleccionados: false,
                esDocumentoDeBaseDeDatos: false,
                CtipoDeDocumento: {
                    TIPOS: { LISTA_ACUERDOS: 1, MINUTA: 2, OTROS: 3 },
                    ID: 'CTipoDeDocumento_VFMDD',
                    KEY: 'KEY_TipoDeDocumento_VFMDD',
                    valorDefinido: 3,
                    opciones: [ { llave: 3, valor: 'Otros (Acuerdo, oficio ....)' } ],
                    mostrarSoloOpcionesValidas: false,
                    contRender: 0,
                    seleccionado: { llave: 3, valor: 'Otros (Acuerdo, oficio ....)' }
                },
                tablaDocumentosSIOP: {
                    ID: 'TDocumentosSIOP_VFMDD',
                    listaDB: [],
                    lista: [],
                    mostrarInfoResultados: false
                },
                verDocumentoSIOP: false,
                visorDeDocumento: {
                    KEY: 'KVisorDeDocumentoSIOP_VFMDD',
                    url: null,
                    height: null,
                    archivo: null,
                    contRender: 0,
                    mostrar: false
                },
                filtros: {
                    tipDeDocumento: 3,
                    consecutivo: null,
                    folio: null
                },
                tablaUsuariosSeleccionados: {
                    ID: 'TUsuarioSeleccionadosFirmaMultiple_VFMDD',
                    lista: [] 
                }
            },
            pendientesDeFirmar: {
                ID: 'TPendientesDeFirmar_VFMDD',
                lista: [],
                listaDB: [],
                visorDeDocumento: {
                    KEY: 'KVisorDeDocumento_VFMDD',
                    url: null,
                    height: '',
                    archivo: null,
                    contRender: 0,
                    mostrar: false
                }
            },
            formularioFirma: {
                archivoFirel: null,
                contrasena: null,
                verContrasena: false,
                camposIngresados: {
                    archivoDeDocumento: false,
                    archivoDePfx: false
                },
                error: {
                    activo: false,
                    mensaje: 'Contraseña de pfx incorrecta',
                },
                TIPOS_ERROR: {
                    passwordIncorrecto: {
                        palabraClave: 'wrong password',
                        textoAMostrar: 'Contraseña ingresada incorrecta, ingresa otra contraseña.'
                    }
                }
            },
            tablaFirmantes: {
                ID: 'TFirmantes_VFMDD',
                lista: [],
                listaDB: []
            },
            firmaElectronica: {
                message: '',
                pkcs7: '',
                activarBoton: false,
                filePFXselct: null,
                password: '',
                extArchivoCargado: ''
            }
        }
    },
    methods: {
        eliminarDocumento:async function(index){
            alert("delete:::"+index)
            console.log("delete::",index)
            const fileListArr = Array.from(this.formularioSolicitud.archivo)
             fileListArr.splice(index, 1) // here u remove the file
            console.log("fileListArr",fileListArr)
           // evento.target.files=fileListArr;
            this.formularioSolicitud.archivo=fileListArr;

            
            console.log("borrado::", this.formularioSolicitud.archivo)
        },
        evtCambioTipoFiltroEstatus: async function(evento) {
            this.CtipoDeEstatusSolicitud.valorDefinido = parseInt(evento.target.value);
            await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
        },
        aplicarFiltradoEstatusDeSolicitud: async function({ tipoDeEstatus }) {
            const { CUALQUIERA, FIRMADO_TODOS, FIRMADO, PENDIENTE } = this.CtipoDeEstatusSolicitud.TIPOS;
            const { ID } = this.pendientesDeFirmar;
            let solicitudes = [];
            switch(tipoDeEstatus) {
                case CUALQUIERA:
                    solicitudes = this.pendientesDeFirmar.lista.sort((a, b) => a.orden - b.orden);
                    break;
                case FIRMADO_TODOS:
                    solicitudes = this.pendientesDeFirmar.lista.filter(s => !s.habilitado && s.estatus == 'Firmado').sort((a, b) => a.orden - b.orden);;
                    break;
                case FIRMADO:
                    solicitudes = this.pendientesDeFirmar.lista.filter(s => !s.habilitado && s.estatus != 'Firmado').sort((a, b) => a.orden - b.orden);;
                    break;
                case PENDIENTE:
                    solicitudes = this.pendientesDeFirmar.lista.filter(s => s.habilitado && s.estatus != 'Firmado').sort((a, b) => a.orden - b.orden);;
                    break;
                default:
                    break;
            }
            //console.log('listaFinal::', solicitudes)
            await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: solicitudes }));
        },
        limpiarFormularioFirmar: function({ cerrarFormulario }) {
            if(cerrarFormulario) {
                $("#modal-firma-documento-VFDD").modal('hide');
            }

            this.formularioFirma.archivoFirel = null;
            $('#f-firma-inpArchivoFirel').val('');
            this.formularioFirma.contrasena = null;
            this.formularioFirma.verContrasena = false;
        },
        limpiarFormularioFirma: function({ cerrarFormulario, conActualizacionDeFilas = { activo: false, filas: [] }, esIndividual = true }) { 
            if(cerrarFormulario)
                $("#modal-firma-documento-VFDD").modal('hide');

            $('#f-firma-inpArchivoFirel').val('');
            this.firmaElectronica.message           = '';
            this.firmaElectronica.pkcs7             = '';
            this.firmaElectronica.activarBoton      = false;
            this.firmaElectronica.filePFXselct      = null;
            this.firmaElectronica.password          = '';
            this.firmaElectronica.extArchivoCargado = '';
            this.formularioFirma.archivoFirel       = null;
            this.formularioFirma.contrasena         = null;
            this.formularioFirma.verContrasena      = false;
            this.formularioFirma.error.activo       = false;
            this.formularioFirma.error.mensaje      = 'Contraseña de pfx incorrecta';
            this.formularioFirma.camposIngresados.archivoDePfx = false;
            this.formularioSolicitud.archivo = null;

            // se actualizan las filas de las solicitudes que se firmaron
            if(conActualizacionDeFilas.activo) {
                conActualizacionDeFilas.filas.forEach(s => { 
                    let solicitudActualizada = this.pendientesDeFirmar.lista.find(m => m.multifirmaId == s.multifirmaId);
                    if(this.campoEsValido(solicitudActualizada)) {
                        solicitudActualizada.seleccionado = false;
                        solicitudActualizada.habilitado   = false;
                        $("#" + this.pendientesDeFirmar.ID).bootstrapTable('updateByUniqueId', {
                            id: solicitudActualizada.multifirmaId,
                            row: solicitudActualizada
                        });
                    }
                });
            }
        },
        ejecutarProcesoGenerarEvidenciaDeFirma: async function({ listaPkcs7, conLoading = false }) {
            let procesoEvidencia = { conError: true, solictudesConEvidencia: [],Error:{},SiHayError:false };
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GENERAR_EVIDENCIAS = await Promise.resolve(this.getPeticionGeneracionEvidenciaFirma({ pkcs7: listaPkcs7 }));
                const { CON_ERROR, RESPUESTA: { Satisfactorio, MultiFirmas,Error,SiHayError } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.FirmaElectronica.funcion.GenerarEvidenciaMultifirma,
                    peticionServicio: PETICION_GENERAR_EVIDENCIAS,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: true, HEADER_PARA_ARRAY_BUFFER: false }
                }));
                // console.log("CON_ERROR",CON_ERROR);
                // console.log("RESPUESTA",Satisfactorio);
                // console.log("RESPUESTA",MultiFirmas);

                if(!CON_ERROR) {
                    procesoEvidencia.solictudesConEvidencia = MultiFirmas;
                    procesoEvidencia.conError = SiHayError;
                    procesoEvidencia.Error = Error;
                }
                else {
                    comun.mensajeDeAlerta("Ocurrio un error al generar el proceso de firma")
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
            return procesoEvidencia;
        },
        getPeticionGeneracionEvidenciaFirma: async function({ pkcs7 }) {debugger
            let peticion = new FormData();
            let evidencias = [];
            pkcs7.forEach(p => { debugger
                let extencionDocumento = 'pdf';
                let multifirmaObj = this.pendientesDeFirmar.lista.find(s => s.multifirmaId == p.MultifirmaId);
                if(multifirmaObj != null && this.campoEsValido(multifirmaObj.rutaDeDocumento)) {
                   extencionDocumento = multifirmaObj.rutaDeDocumento.split(".").pop();
                   extencionDocumento = (this.campoEsValido(extencionDocumento) && (extencionDocumento == 'doc' || extencionDocumento == 'DOC' || extencionDocumento == 'bz2')) ? 'docx' : extencionDocumento;
                }
                let pkcs7Blob  = new Blob([p.pkcs7], {type:'text/plain'});
                let refNombreArchivo = `llavePrivadaPEM_${ p.MultifirmaId }_.txt`;
                peticion.append('pkcs7Blob',new File([pkcs7Blob], refNombreArchivo));
                let multifirma = { NombreDelArchivo: refNombreArchivo, SolicitudId: p.MultifirmaId, ExtencionDeDocumento: extencionDocumento };
                evidencias.push(multifirma);
            });
            peticion.append('EsPrueba',false); 
            peticion.append('Multifirma',JSON.stringify(evidencias)); 
            return peticion;
        },
        ejecutarProcesoFirmaDeDocumentos: async function() {
            $("#modal-firma-documento-VFDD").modal('hide');
            try {
                comun.SeEstaCargandoInformacion(true);
                const { filePFXselct, password } = this.firmaElectronica;
                const { TIPOS_ERROR: { passwordIncorrecto } } = this.formularioFirma;
                const { conError, errorMsj, respuesta: { certPEM, privateKeyPem, message } } = await OpenPfx({ ctrlFile: filePFXselct, password });
                /* console.log('conError::',conError);
                console.log('certPEM::',certPEM);
                console.log('privateKeyPem::',privateKeyPem);
                console.log('message::',message); */
                if(!conError) {
                    const PETICION_FIRMAR_DOCUMENTOS = await Promise.resolve(this.getPeticionFirmar({ certPemSTR: certPEM, privateKeyPemSTR: privateKeyPem }));
                    const { CON_ERROR, RESPUESTA: { Satisfactorio, entidad } }  = await Promise.resolve(servicioRestPost({
                        servicioUrl: api.FirmaElectronica.funcion.GuardarArchivosPEM,
                        peticionServicio: PETICION_FIRMAR_DOCUMENTOS,
                        headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: true, HEADER_PARA_ARRAY_BUFFER: false }
                    }));
                    comun.SeEstaCargandoInformacion(false);

                    if(!CON_ERROR) {
                        comun.mensajeDeAlerta(Satisfactorio);
                        /* console.log('entidad::', entidad); */
                        if(this.campoEsValido(entidad)) {
                            let listaPkcs7 = [];
                            for(let i=0; i < entidad.length; i++) {
                                let firmaMultiple = entidad[i];
                                if(this.campoEsValido(firmaMultiple.Certificados) && this.campoEsValido(firmaMultiple.DocumentoCodificado)) {
                                    let certificadosYLLavesDecodificadas = await Promise.resolve(this.decodificarCertificadoYLLavesDeFirmantes({ certificadosYLLavesFirmantes: firmaMultiple.Certificados }));
                                    /* console.log('decodificacionCertificados::',certificadosYLLavesDecodificadas); */
                                    let documentoDecodificado = await Promise.resolve(ObtenerHexDeBase64({ base64STR: firmaMultiple.DocumentoCodificado }));
                                    /* console.log('decodificacionDocumento::',documentoDecodificado); */
                                    if(this.campoEsValido(certificadosYLLavesDecodificadas) && this.campoEsValido(documentoDecodificado)) {
                                        let pkcs7 = this.CreatePKCS7({ informacionFirmantes: certificadosYLLavesDecodificadas, contenidoDocumentoAFirmar: documentoDecodificado });
                                        listaPkcs7.push( { MultifirmaId: firmaMultiple.MultifirmaId, pkcs7: pkcs7 } );
                                    }
                                }
                            }

                            if(this.campoEsValido(listaPkcs7)) {
                                /* for(let i=0; i< listaPkcs7.length; i++) {
                                    let pkcs7 = listaPkcs7[i];
                                    console.log('generadodddddddddddddddddddddddddddddddddddddd::',pkcs7);
                                    await Promise.resolve(this.saveTextAsFile({ element: pkcs7.pkcs7 }));
                                } */
                                const { conError, solictudesConEvidencia,Error,SiHayError } = await Promise.resolve(this.ejecutarProcesoGenerarEvidenciaDeFirma({ listaPkcs7: listaPkcs7 }));
                                console.log("conError::",conError)
                                console.log("solictudesConEvidencia::",solictudesConEvidencia)
                                console.log("Error::",Error)
                                console.log("SiHayError::",SiHayError)
                                if(!conError) {
                                    this.pendientesDeFirmar.lista = this.pendientesDeFirmar.lista.map(s => {
                                        let solicitudFirmada = solictudesConEvidencia.find(sF => sF.multifirmaId == s.multifirmaId);
                                        if(solicitudFirmada != null) {
                                            s.estatus = 'Firmado';
                                            s.rutaDeDocumentoFirmado = solicitudFirmada.rutaDeDocumentoFirmado;
                                            s.estatusSTR = `<div class="form-inline justify-content-center">
                                                                <div class="estatus-firmado-VFDD">
                                                                    Firmado
                                                                </div>
                                                            </div>`;
                                            s.documento = `<button type="button" title="ver documento de la solicitud firmado" class="btn btn-sm btn-verDocumentoFirmado-VFDD  btn-info">
                                                                    <i class="fas fa-file-signature"></i>
                                                            </button>`;
                                            s.orden = 2;
                                        }
                                        return s;
                                    });
                                    comun.mensajeDeAlerta('la evidencia se genero correctamente');
                                    const FILAS_PARA_ACTUALIZAR = this.pendientesDeFirmar.lista.filter(s => s.seleccionado);
                        this.limpiarFormularioFirma({ cerrarFormulario: true, conActualizacionDeFilas: { activo: true, filas: FILAS_PARA_ACTUALIZAR } });
                        await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                                }else{
                                   // comun.mensajeDeAlerta(Error.Mensaje);
                                   // console.log('errorMsj::',errorMsj);
                                    const FILAS_PARA_ACTUALIZAR = this.pendientesDeFirmar.lista.filter(s => s.seleccionado);
                        this.limpiarFormularioFirma({ cerrarFormulario: true, conActualizacionDeFilas: { activo: true, filas: FILAS_PARA_ACTUALIZAR } });
                        await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                                    this.formularioFirma.error.activo = true;
                                    this.formularioFirma.error.mensaje = Error.Mensaje;
                                    comun.SeEstaCargandoInformacion(false);
                                    $("#modal-firma-documento-VFDD").modal('show');
                                }
                            }

                        }
                        // const FILAS_PARA_ACTUALIZAR = this.pendientesDeFirmar.lista.filter(s => s.seleccionado);
                        // this.limpiarFormularioFirma({ cerrarFormulario: true, conActualizacionDeFilas: { activo: true, filas: FILAS_PARA_ACTUALIZAR } });
                        // await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                    }
                    else {
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta('Ocurrio un error al generar la firma');
                    }
                }
                else {
                    console.log('errorMsj::',errorMsj);
                    this.formularioFirma.error.activo = true;
                    this.formularioFirma.error.mensaje = (errorMsj.includes(passwordIncorrecto.palabraClave)) ? passwordIncorrecto.textoAMostrar : this.formularioFirma.error.mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    $("#modal-firma-documento-VFDD").modal('show');
                }
            }
            catch(error) {
                console.error(error);
            }
            comun.SeEstaCargandoInformacion(false);
        },
        decodificarCertificadoYLLavesDeFirmantes: async function({ certificadosYLLavesFirmantes }) {
            let certificadosYLLavesDecodificadas = [];
            for(let i=0; i< certificadosYLLavesFirmantes.length; i++) {
                let llaveYCertificado = certificadosYLLavesFirmantes[i];
                /* console.log('llaveYCertificadoObj::',llaveYCertificado); */
                let certificadoSTR = await Promise.resolve(ObtenerStringDeBase64({ base64STR: llaveYCertificado.Certificado }));
                /* console.log('certificadoSTR::',certificadoSTR); */
                let llavePrivadaSTR = await Promise.resolve(ObtenerStringDeBase64({ base64STR: llaveYCertificado.Llave }));
                /* console.log('llavePrivadaSTR::',llavePrivadaSTR); */
                if(certificadoSTR.error.activo || llavePrivadaSTR.error.activo || !this.campoEsValido(certificadoSTR.mensajeDeCodificado) || !this.campoEsValido(llavePrivadaSTR.mensajeDeCodificado)) {
                    throw "Error en decodificación de llaves";
                }
                else {
                    certificadosYLLavesDecodificadas.push({ certificado: certificadoSTR.mensajeDeCodificado, llavePrivada: llavePrivadaSTR.mensajeDeCodificado });
                }
            }
            return certificadosYLLavesDecodificadas;
        },
        CreatePKCS7: function({ informacionFirmantes, contenidoDocumentoAFirmar }) { debugger
            let pkcs7 = null;
            let certificados = informacionFirmantes.map(i => i.certificado);
            let informacionFirmantesObj = informacionFirmantes.map(i => {
                let signerInfo = {};
                signerInfo.hashAlg = 'sha256';
                let sAttr = new Object();
                sAttr.SigningTime = new Object();
                signerInfo.sAttr = sAttr;
                signerInfo.signerCert = i.certificado;
                signerInfo.sigAlg = 'SHA256withRSA';
                signerInfo.signerPrvKey = i.llavePrivada;
                return signerInfo;
            });
            var param = {
                content: { hex: contenidoDocumentoAFirmar.hexadecimal },
                certs: certificados,
                signerInfos: informacionFirmantesObj
            };  
            /* console.log('signedData::params::',param) */
            try {
                var signedData = KJUR.asn1.cms.CMSUtil.newSignedData(param);
                /* console.log('signedData::',signedData)
                console.log(signedData.getPEM()); */
                pkcs7 = RemoveCMSHeader({ cms: signedData.getPEM() }); 
            } catch (error) {
                console.error(error);
            }
            return pkcs7;

            /* Version estable de pruebas
            let pkcs7 = null;
            var param = {
                content: { hex: message },
                certs: [certPEM],
                signerInfos: [{
                    hashAlg: 'sha256',
                    sAttr: {
                        SigningTime: {}
                    },
                    signerCert: certPEM,
                    sigAlg: 'SHA256withRSA',
                    signerPrvKey: privateKeyPEM
                }]
            };  
            
            try {
                var signedData = KJUR.asn1.cms.CMSUtil.newSignedData(param);
                console.log(signedData.getPEM());
                pkcs7 = RemoveCMSHeader({ cms: signedData.getPEM() }); 
            } catch (error) {
                console.error(error);
            }
            return pkcs7; */
        },
        getPeticionFirmar: async function({ certPemSTR, privateKeyPemSTR }) {
            let peticion = new FormData();
            let certificadoPemBlob  = new Blob([certPemSTR], {type:'text/plain'});
            let llavePrivadaPemBlob = new Blob([privateKeyPemSTR], {type:'text/plain'});
            let solicitudesAFirmar = this.pendientesDeFirmar.lista.filter(s => s.seleccionado).map(s => {
                let multifirmaObj = { 
                    UsuarioId: this.idUsuario,
                    MultifirmaId: s.multifirmaId,
                    FechaEnQueFirmo: moment() 
                };
                return multifirmaObj;
            });
            peticion.append('EsPrueba',false); 
            peticion.append('FirmaMultiple',JSON.stringify(solicitudesAFirmar));
            peticion.append('CertificadoPEM',new File([certificadoPemBlob], "certificadoPEM.txt")); 
            peticion.append('LLavePEM',new File([llavePrivadaPemBlob], "llavePrivadaPEM.txt"));  
            return peticion;
        },
        mostrarTablaUusariosSeleccionados: async function() {
            this.formularioSolicitud.tablaUsuariosSeleccionados.lista = this.formularioSolicitud.tablaUsuarios.lista.filter(u => u.seleccionado);

            if(this.campoEsValido(this.formularioSolicitud.tablaUsuariosSeleccionados.lista)) {
                this.formularioSolicitud.tablaUsuariosSeleccionados.lista = this.formularioSolicitud.tablaUsuariosSeleccionados.lista.filter(u => u.seleccionado).map(u => {
                    let usuarioObj = { ...u };
                    usuarioObj.accionRemover = `<button type="button" title="remover firmante de la lista" class="btn btn-sm btn-danger accion-remover-usr-seleccionados">
                                                    <i class="fas fa-trash"></i>
                                                 </button>`;
                    return usuarioObj;
                });
                this.formularioSolicitud.verUsuariosSeleccionados = true;
                $('#' + this.formularioSolicitud.tablaUsuariosSeleccionados.ID).bootstrapTable('destroy')
                await Promise.resolve(this.inicializarTabla({ idReferencia: this.formularioSolicitud.tablaUsuariosSeleccionados.ID, elementos: this.formularioSolicitud.tablaUsuariosSeleccionados.lista }));
            }
            else {
                this.formularioSolicitud.verUsuariosSeleccionados = false;
            }
        },
        eventoCheckDocumentos: async function(documento) {
            console.log('row::', documento);
             const REQUEST = { AcuerdoId: documento.folio };
            if(!this.campoEsValido(documento.rutaDeArchivo)) {
                 $('#modal-creacion-solicitud-VFDD').modal('hide');
                const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.FirmaElectronica.funcion.ObtenerPathDocumentoMajat,
                    peticionServicio: REQUEST,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false },

                }));
                $('#modal-creacion-solicitud-VFDD').modal('show');
                console.log('eventoCheckDocumentos::', RESPUESTA);

                let filaActualizada = this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.folio == documento.folio);
                if(CON_ERROR || !this.campoEsValido(RESPUESTA.Satisfactorio)) {
                    alert("El acuerdo seleccionado no cuenta con archivo");
                    filaActualizada.seleccionado = false;
                }
                else {
                    filaActualizada.rutaDeArchivo = RESPUESTA.Satisfactorio;
                }

                $("#" + this.formularioSolicitud.tablaDocumentosSIOP.ID).bootstrapTable('updateByUniqueId', {
                    id: documento.folio,
                    row: filaActualizada
                });
            }
        },
        ejecutarProcesoBusquedaDocumentoSIOP: async function() {
            try {
                this.formularioSolicitud.tablaDocumentosSIOP.mostrarInfoResultados = true;
                const { tipDeDocumento, consecutivo, folio } = this.formularioSolicitud.filtros;
                $("#modal-creacion-solicitud-VFDD").modal('hide');
                comun.SeEstaCargandoInformacion(true);
                const ID_TIPO_DOC_ACUERDO_MAJAT = 11;
                const PETICION_GET_DOCUMENTOS_SIOP = {
                    TipoDeDocumento: ID_TIPO_DOC_ACUERDO_MAJAT,
                    Folio: folio,
                    NumeroDeExpediente: consecutivo
                };
                const { CON_ERROR, RESPUESTA: { DocumentosDeSIOP } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.FirmaElectronica.funcion.ObtenerDocumentosMajat,
                    peticionServicio: PETICION_GET_DOCUMENTOS_SIOP,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    const { ID } = this.formularioSolicitud.tablaDocumentosSIOP;
                    this.formularioSolicitud.tablaDocumentosSIOP.lista = (this.campoEsValido(DocumentosDeSIOP))
                        ? DocumentosDeSIOP.map(d => {
                            let documentoObj = { ...d };
                            documentoObj.documentoSTR = `<button type="button" class="btn btn-sm btn-accion-docuemntos-siop btn-firmantes-VFDD btn-info">
                                                                <i class="fas fa-file"></i>
                                                         </button>`;
                            documentoObj.seleccionado = false;
                            return documentoObj;
                        }) : [];

                    // se actualiza la tabla 
                    $('#' + ID).bootstrapTable('destroy')
                    await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioSolicitud.tablaDocumentosSIOP.lista, callbackCheck: this.eventoCheckDocumentos }));
                }
                comun.SeEstaCargandoInformacion(false);

                /* console.log('DocumentosDeSIOP::',DocumentosDeSIOP); */
                $("#modal-creacion-solicitud-VFDD").modal('show');
            }
            catch(error) {
                $("#modal-creacion-solicitud-VFDD").modal('show');
            }
        },
        evtCambioTipoDeDocumento: function(evento) {
            this.formularioSolicitud.filtros.tipDeDocumento = parseInt(evento.target.value);
            this.formularioSolicitud.CtipoDeDocumento.valorDefinido = parseInt(evento.target.value);
        },
        ejecutarProcesoCreacionDeSolicitud: async function() {
            try {
                // se regresa la lista principal de solicitude para insertar los nuevos registros
                let filtroPrevioEstatus = this.CtipoDeEstatusSolicitud.valorDefinido;
                if(filtroPrevioEstatus != this.CtipoDeEstatusSolicitud.TIPOS.CUALQUIERA) {
                    this.CtipoDeEstatusSolicitud.valorDefinido = this.CtipoDeEstatusSolicitud.TIPOS.CUALQUIERA;
                    await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                }

                $("#modal-creacion-solicitud-VFDD").modal('hide');
                const PETICION_GUARDAR_SOLICITUD = await Promise.resolve(this.getPeticionGuardarSolicitud());
                console.log("PETICION:;",PETICION_GUARDAR_SOLICITUD)
                const { CON_ERROR, RESPUESTA: { Multifirma, Satisfactorio } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.FirmaElectronica.funcion.GuardarSolicitudFirmaMultiple,
                    peticionServicio: PETICION_GUARDAR_SOLICITUD,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: true, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    const { ID } = this.pendientesDeFirmar;
                    if(this.formularioSolicitud.tablaUsuarios.lista.filter(u => u.seleccionado).some(u => u.IdUsuario == this.idUsuario)) {
                       console.log("Multifirma:::",Multifirma);
                       console.log("this.pendientesDeFirmar.lista.length::",this.pendientesDeFirmar.lista.length);
                       for(var i = 0; i<Multifirma.length;i++){
                        const ULTIMA_FILA = ((this.pendientesDeFirmar.lista.length -1) + (i+1));
                        console.log("ULTIMA_FILA::",ULTIMA_FILA)
                        console.log("nuevaFirma::", Multifirma[i])
                        $("#" + ID).bootstrapTable('insertRow', {
                            index: ULTIMA_FILA,
                            row: this.obtenerSolictudObjConFormatoTabla({ solicitud: Multifirma[i] })
                        });  

                       }
                    
                       
               
                        // const ULTIMA_FILA = ((this.pendientesDeFirmar.lista.length -1) + 1);
                        // $("#" + ID).bootstrapTable('insertRow', {
                        //     index: ULTIMA_FILA,
                        //     row: this.obtenerSolictudObjConFormatoTabla({ solicitud: Multifirma })
                        // });
                        //await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                    }
                    
                    if(filtroPrevioEstatus != this.CtipoDeEstatusSolicitud.TIPOS.CUALQUIERA) {
                        this.CtipoDeEstatusSolicitud.valorDefinido = filtroPrevioEstatus;
                        await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                    }
                    await Promise.resolve(this.aplicarFiltradoEstatusDeSolicitud({ tipoDeEstatus: this.CtipoDeEstatusSolicitud.valorDefinido }));
                    comun.mensajeDeAlerta(Satisfactorio);
                    this.limpiarSeccionCreacionSolicitud();
                }
                else {
                    $("#modal-creacion-solicitud-VFDD").modal('show');
                }
            }
            catch(error) {
                $("#modal-creacion-solicitud-VFDD").modal('show');
            }
        },
        limpiarSeccionCreacionSolicitud: async function() {
            const { tablaUsuarios: { ID }, tablaDocumentosSIOP } = this.formularioSolicitud;
            // filtros de busqueda documento de siop
            this.formularioSolicitud.esDocumentoDeBaseDeDatos = false;
            this.formularioSolicitud.verDocumentoSIOP = false;
            this.formularioSolicitud.filtros.TipoDeDocumento = 3;
            this.formularioSolicitud.filtros.consecutivo = null;
            this.formularioSolicitud.filtros.folio = null;
            this.formularioSolicitud.CtipoDeDocumento.valorDefinido = 3;
            this.formularioSolicitud.CtipoDeDocumento.seleccionado =  { llave: 3, valor: 'Otros (Acuerdo, oficio ....)' };
            this.formularioSolicitud.tablaDocumentosSIOP.lista = this.formularioSolicitud.tablaDocumentosSIOP.lista.map(d => {
                let documentoObj = { ...d };
                documentoObj.seleccionado = false;
                return documentoObj;
            });
            $('#' + tablaDocumentosSIOP.ID).bootstrapTable('destroy');

            // se limpian los valores del formulario
            //this.formularioSolicitud.descripcion = null;
            this.formularioSolicitud.esDocumentoDeBaseDeDatos = false;
            this.formularioSolicitud.archivo = null;
            this.formularioSolicitud.verUsuariosSeleccionados = false;
            $("#f-solicitud-inpDocumento").val('');
            this.formularioSolicitud.tablaUsuarios.lista = this.formularioSolicitud.tablaUsuarios.lista.map(u => {
                let usuarioObj = { ...u };
                usuarioObj.seleccionado = (u.IdUsuario == this.idUsuario);
                return usuarioObj;
            });

            // se actualiza la tabla de usuarios
            $('#' + ID).bootstrapTable('destroy')
            await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioSolicitud.tablaUsuarios.lista }));
            this.formularioSolicitud.tablaDocumentosSIOP.mostrarInfoResultados = false;
        },
        getPeticionGuardarSolicitud: async function() {debugger
            const { tablaUsuarios: { lista }, descripcion, archivo } = this.formularioSolicitud;
            let documentoSIOP = (this.formularioSolicitud.esDocumentoDeBaseDeDatos) ? this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado) : null;
            
            let peticion = new FormData();
            const MULTIFIRMA = {
                multifirmaId: -1,
                descripcion: descripcion,
                fechaDeSolicitud: moment(),
                rutaDeDocumento: (this.formularioSolicitud.esDocumentoDeBaseDeDatos) ? documentoSIOP.rutaDeArchivo : null,
                rutaDeDocumentoFirmado: null,
                estatus: null
            };
            const FIRMANTES = lista.filter(f => f.seleccionado).map(f => {
                let frimanteObj = { ...f };
                delete frimanteObj['seleccionado'];
                delete frimanteObj['habilitado'];
                return f;
            });
            peticion.append('EsPrueba',false); 
            peticion.append('SolicitudMultifirma',JSON.stringify(MULTIFIRMA)); 
            peticion.append('Firmantes',JSON.stringify(FIRMANTES));
            peticion.append('EsDocumentoDeBaseDeDatos',this.formularioSolicitud.esDocumentoDeBaseDeDatos);

            if(!this.formularioSolicitud.esDocumentoDeBaseDeDatos)
                archivo.forEach(function(documento,indice){
                    peticion.append('ArchivoDeDocumento'+indice,documento);
                })
             //   peticion.append('ArchivoDeDocumento',archivo);

                console.log("peticion::",peticion)
            return peticion;
        },
        evtSeleccionarArchivoDeDocumento: async function(evento) {
            try{
                const ARCHIVO_BLOB = evento.target.files[0];
                this.formularioSolicitud.archivo = ARCHIVO_BLOB;

                const { conError } = await SelectFileSign({ ctrlFile: evento.target });
                if(!conError) {
                    this.formularioFirma.camposIngresados.archivoDeDocumento = true;
                    this.firmaElectronica.message = elementosDeFirma.message;
                    this.firmaElectronica.extArchivoCargado = elementosDeFirma.extFileUpload;
                }
            }
            catch(error) {
                alert('Ha sucedido un error al cargar el archivo, vuelve a intentarlo');
                comun.mensajeDeAlerta(error);
            }
        },
        evtSeleccionDeArchivoPFX: async function(evento) { 
            try{
                const ARCHIVO_BLOB = evento.target.files[0];
                this.formularioSolicitud.archivo = ARCHIVO_BLOB;

                this.firmaElectronica.activarBoton = SelectPfx({ pfxFile: evento.target });
                if(this.firmaElectronica.activarBoton){
                    this.formularioFirma.camposIngresados.archivoDePfx = true;
                    this.firmaElectronica.filePFXselct = evento.target;
                }
            }
            catch(error) {
                alert('Ha sucedido un error al cargar el archivo, vuelve a intentarlo');
                comun.mensajeDeAlerta(error);
            }
        },
        ejecutarProcesoFirmar: async function() { 
            $("#modal-firma-documento-VFDD").modal('hide');
            try {
                comun.SeEstaCargandoInformacion(true);
                const { filePFXselct, password } = this.firmaElectronica;
                const { TIPOS_ERROR: { passwordIncorrecto } } = this.formularioFirma;
                const { conError, errorMsj, respuesta: { certPEM, privateKeyPem, message } } = await OpenPfx({ ctrlFile: filePFXselct, password });
                /* console.log('conError::',conError);
                console.log('certPEM::',certPEM);
                console.log('privateKeyPem::',privateKeyPem);
                console.log('message::',message); */
                if(!conError) {
                    this.formularioFirma.error.activo = false;
                    this.formularioFirma.error.mensaje = 'Contraseña de pfx incorrecta';
                    let pkcs7 = this.CreatePKCS7({ certPEM: certPEM, privateKeyPEM: privateKeyPem, message: message })
                    await Promise.resolve(this.saveTextAsFile({ element: pkcs7 }));
                    this.limpiarFormularioFirmar({ cerrarFormulario: true });
                }
                else {
                    console.log('errorMsj::',errorMsj);
                    this.formularioFirma.error.activo = true;
                    this.formularioFirma.error.mensaje = (errorMsj.includes(passwordIncorrecto.palabraClave)) ? passwordIncorrecto.textoAMostrar : this.formularioFirma.error.mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    $("#modal-firma-documento-VFDD").modal('show');
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(error) {
                console.log(error);
                comun.SeEstaCargandoInformacion(false);
            }
        },
        saveTextAsFile: async function({ element }) { 
            var fecha = new Date();
            /* console.info(fecha.valueOf()); */
        
            let textToWrite = element;
            /* console.info('pkcs7::Valor::' + element); */
            let textFileAsBlob = new Blob([textToWrite], {type:'text/plain'});
            let fileNameToSaveAs = "pkcs7_" + fecha.valueOf() + "."+this.firmaElectronica.extArchivoCargado;
            saveAs(textFileAsBlob, fileNameToSaveAs);
        },
        mostrarModalFormularioFirmar: function() {
            $("#modal-firma-documento-VFDD").modal('show');
        },
        mostrarFormularioCreacionSolicitud: async function() {
            $("#modal-creacion-solicitud-VFDD").modal('show');
        },
        iniciarProcesoCreacionDeSolicitud: function() {
            this.limpiarSeccionCreacionSolicitud();
            $("#modal-creacion-solicitud-VFDD").modal('hide');
            $("#modal-mostrar-seccion-firmar-VFDD").modal('show');
        },
        mostrarSeccionParaFirmarDocumento: function() {
            this.cerrarModalConfirmacion({ referencia: 'modal-mostrar-seccion-firmar-VFDD' });
            $("#modal-firma-documento-VFDD").modal('show');
        },
        cerrarModalConfirmacion: function({ referencia }) {
            $("#" + referencia).modal('hide');
        },
        evtCargarDocumentoSeleccionado: function(evento) { debugger
            try{
                console.log("evento.target.files",evento.target.files)
                const ARCHIVO_BLOB = evento.target.files;
                this.formularioSolicitud.archivo = ARCHIVO_BLOB;
                console.log(" this.formularioSolicitud.archivo::", this.formularioSolicitud.archivo)
                
        

            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        inicializarTabla: async function({ idReferencia, elementos, callbackCheck = (row) => {} }) { 
            this.$nextTick(() => {
                $("#" + idReferencia).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $("#" + idReferencia).bootstrapTable({  data: elementos });      
                $("#" + idReferencia).bootstrapTable('load', elementos ); 
                $("#" + idReferencia).on('check.bs.table',(e, row) => {
                    callbackCheck(row);
                });
                $("#" + idReferencia).on('uncheck.bs.table',(e, row) => {
                    callbackCheck(row);
                });
                $("#" + idReferencia).on('check-all.bs.table',(e, rows) => {
                    callbackCheck();
                });
                $("#" + idReferencia).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    callbackCheck();
                });
            });
        },
        campoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        cargarInformacionFirmantesDeSolicitudes: async function({ multifirma, conLoading = false }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            // se obtiene la informacion de los usuarios
            const PETICION_GET_FIRMANTES_SOLICITUD = { EsPrueba: false, MultiFirma: { multifirmaId: multifirma.multifirmaId } };
            const { CON_ERROR, RESPUESTA: { Firmantes } }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.FirmaElectronica.funcion.ObtenerFirmantesSolicitudMultifirma,
                peticionServicio: PETICION_GET_FIRMANTES_SOLICITUD,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));

            // se mapea la informacion al fromato de firmantes para el formulario
            this.tablaFirmantes.lista = (!CON_ERROR && this.campoEsValido(Firmantes)) 
                ? Firmantes.map(f => {
                    let firmanteObj = { ...f };
                    firmanteObj.FechaCuandoFirmo = this.campoEsValido(firmanteObj.FechaCuandoFirmo) ? moment(firmanteObj.FechaCuandoFirmo).format('YYYY-MM-DD') : '-';
                    firmanteObj.firmoSTR = (firmanteObj.firmo) ? '<strong><i class="fas fa-signature text-warning" title="ya ha sido firmado"></i></strong>' : '-';
                    return firmanteObj;
                }) : [];
            if(conLoading)
                comun.SeEstaCargandoInformacion(false);

            const { ID } = this.tablaFirmantes;
            $('#' + ID).bootstrapTable('destroy');
            $("#modal-informacion-firmantes-VFDD").modal('show');

            // se inicializa la tabla de frimantes para el formulario creacion de solicitud
            this.$nextTick(async () => {
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.tablaFirmantes.lista }));
            });
        },
        cargarInformacionDeFirmantes: async function() {
            // se obtiene la informacion de los usuarios
            const PETICION_GET_FIRMANTES = { EsPrueba: false };
            const { CON_ERROR, RESPUESTA: { Firmantes, IdUsuario, IdMateriaAreaDeUsuario,  EsUsuarioMajat} }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.FirmaElectronica.funcion.ObtenerFirmantes,
                peticionServicio: PETICION_GET_FIRMANTES,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));

            const SE_ENCONTRARON_USUARIOS = !CON_ERROR && this.campoEsValido(Firmantes);

            // se poner como principal al usuario del sistema
            if(SE_ENCONTRARON_USUARIOS) {
                Firmantes.forEach(function(firmante,i) {
                    if(firmante.IdUsuario == IdUsuario){
                        Firmantes.splice(i, 1);
                        Firmantes.unshift(firmante);
                    }
                });
            }
            // se mapea la informacion al fromato de firmantes para el formulario
            this.formularioSolicitud.tablaUsuarios.lista = (SE_ENCONTRARON_USUARIOS) 
                ? Firmantes
                .map(f => {
                    let firmanteObj = { ...f };
                    firmanteObj.seleccionado = (f.IdUsuario == IdUsuario);
                    return firmanteObj;
                }) : [];
            this.idUsuario = IdUsuario;
            this.materiaAreaDeUsuarioId = IdMateriaAreaDeUsuario;
            this.MAJAT.usuarioRegistrado = EsUsuarioMajat;

            // se inicializa la tabla de frimantes para el formulario creacion de solicitud
            this.$nextTick(async () => {
                const { ID } = this.formularioSolicitud.tablaUsuarios;
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioSolicitud.tablaUsuarios.lista }));
            });
        },
        cargarInformacionDeSolicitudes: async function({ conLoading }) {
            // se regresan los filtros al inicial
            this.CtipoDeEstatusSolicitud.valorDefinido = this.CtipoDeEstatusSolicitud.TIPOS.CUALQUIERA;
            this.CtipoDeEstatusSolicitud.contRender ++;

            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            // se obtiene la informacion de los usuarios
            const PETICION_GET_SOLICITUDES = { EsPrueba: false };
            const { CON_ERROR, RESPUESTA: { Solicitudes } }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.FirmaElectronica.funcion.ObtenerSolicitudesMultifirma,
                peticionServicio: PETICION_GET_SOLICITUDES,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));

            // se mapea la informacion al fromato de firmantes para el formulario
            this.pendientesDeFirmar.lista = (!CON_ERROR && this.campoEsValido(Solicitudes)) 
                ? Solicitudes.map(s => { 
                    return this.obtenerSolictudObjConFormatoTabla({ solicitud: s });
                }) : [];
            
            // se inicializa la tabla de frimantes para el formulario creacion de solicitud
            this.$nextTick(async () => {
                const { ID } = this.pendientesDeFirmar;
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.pendientesDeFirmar.lista }));
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            });
        },
        obtenerSolictudObjConFormatoTabla: function({ solicitud }) {
            let solicitudObj = { ... solicitud };
            solicitudObj.estatusSTR         = `<div class="form-inline justify-content-center">
                                                        <div class="${ (solicitud.estatus == 'Firmado') ? 'estatus-firmado-VFDD' : 'estatus-sin-firma-VFDD' }">
                                                            ${ (solicitud.estatus == 'Firmado') ? solicitud.estatus : 'Pendiente' }
                                                        </div>
                                                    </div>`;
            solicitudObj.numeroFirmantes    = `<button type="button" class="btn btn-sm btn-listado-firmantes-accion-VFDD btn-firmantes-VFDD btn-info">
                                                    <i class="fas fa-user"></i>&nbsp;&nbsp;${ solicitud.numeroFirmantes }
                                               </button>`;
            solicitudObj.documento          = `<button type="button" title="${ this.campoEsValido(solicitud.rutaDeDocumentoFirmado) ? 'ver documento de la solicitud firmado' : 'ver documento de la solicitud' }" class="btn btn-sm ${ (this.campoEsValido(solicitud.rutaDeDocumentoFirmado)) ? 'btn-verDocumentoFirmado-VFDD' : 'btn-verDocumento-VFDD' }  btn-info">
                                                    <i class="${ (this.campoEsValido(solicitud.rutaDeDocumentoFirmado)) ? 'fas fa-file-signature' : 'fas fa-file' }"></i>
                                               </button>`;
            solicitudObj.seleccionado = false;
            solicitudObj.habilitado   = !solicitud.usuarioYaAgregoSuFirma;
            solicitudObj.fechaDeSolicitud = moment(solicitudObj.fechaDeSolicitud).format('YYYY-MM-DD');
            return solicitudObj;
        },
        mostrarDocumentoDeSolicitud: function({ solicitud }) {
            console.log("solicitudsolicitud ",solicitud)
            this.pendientesDeFirmar.visorDeDocumento.url = (this.campoEsValido(solicitud.rutaDeDocumentoFirmado)) ? solicitud.rutaDeDocumentoFirmado : solicitud.rutaDeDocumento;
            this.pendientesDeFirmar.visorDeDocumento.mostrar = true;
            this.pendientesDeFirmar.visorDeDocumento.contRender ++;
            $("#modal-documento-solicitud-VFDD").modal('show');
        },
        mostrarDocumentoDeSIOP: async function({ documento }) {
            const REQUEST = { AcuerdoId: documento.folio };
            if(!this.campoEsValido(documento.rutaDeArchivo)) {
                $('#modal-creacion-solicitud-VFDD').modal('hide');
                const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.FirmaElectronica.funcion.ObtenerPathDocumentoMajat,
                    peticionServicio: REQUEST,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false },

                }));
                $('#modal-creacion-solicitud-VFDD').modal('show');
                console.log('mostrarDocumentoDeSIOP::', RESPUESTA);

                let filaActualizada = this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.folio == documento.folio);
                if(!CON_ERROR && this.campoEsValido(RESPUESTA.Satisfactorio)) {
                    filaActualizada.rutaDeArchivo = RESPUESTA.Satisfactorio;
                    this.formularioSolicitud.visorDeDocumento.url = filaActualizada.rutaDeArchivo;
                    this.formularioSolicitud.visorDeDocumento.contRender ++;
                    this.formularioSolicitud.verDocumentoSIOP = true;
                }
                else {
                    alert("El acuerdo seleccionado no cuenta con archivo");
                    filaActualizada.seleccionado = false;
                }

                $("#" + this.formularioSolicitud.tablaDocumentosSIOP.ID).bootstrapTable('updateByUniqueId', {
                    id: documento.folio,
                    row: filaActualizada
                });
            }
            else {
                this.formularioSolicitud.visorDeDocumento.url = documento.rutaDeArchivo;
                this.formularioSolicitud.visorDeDocumento.contRender ++;
                this.formularioSolicitud.verDocumentoSIOP = true;
            }
        },
        removerUsrSeleccionadoDesdeSeccion: function({ usuario }) { 
            // se elimina de la tabla de usuarios seleccionados 
            $("#" + this.formularioSolicitud.tablaUsuariosSeleccionados.ID).bootstrapTable('remove', {
                field: 'IdUsuario',
                values: [usuario.IdUsuario]
            });

            // se actualiza el valor de la tabla principal de seleccion de usuarios
            let usuarioObj = this.formularioSolicitud.tablaUsuarios.lista.find(u => u.IdUsuario == usuario.IdUsuario);
            usuarioObj.seleccionado = false;
            if(this.campoEsValido(usuarioObj)) {
                $("#" + this.formularioSolicitud.tablaUsuarios.ID).bootstrapTable('updateByUniqueId', {
                    id: usuario.IdUsuario,
                    row: usuarioObj
                });
            }
        }
    },
    computed: {
        mostrarAccionesDeSIOP() {
           return this.AREAS_SIOP.some(aId => aId == this.materiaAreaDeUsuarioId);
        },
        documentoDeSolicitudYaFueIngresado() {
            return (
                this.formularioSolicitud.esDocumentoDeBaseDeDatos 
                    ? this.campoEsValido(this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado))
                    : this.campoEsValido(this.formularioSolicitud.archivo)
            );
        },
        documentoDeSIOPEstaSeleccionado() {
            return this.campoEsValido(this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado))
        },
        getDocumentoSeleccionadoDeSIOP() {
            return (
                this.campoEsValido(this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado))
                    ? `Seleccionado: [ Folio: ${ this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado).folio } ]` : ''
            );
        },
        mostraNumeroDeExpedienteEnFormulario() {
            return (
                this.formularioSolicitud.CtipoDeDocumento.valorDefinido == this.formularioSolicitud.CtipoDeDocumento.TIPOS.LISTA_ACUERDOS
            );
        },
        numeroDeFirmatesRestantesParaCompletarFirma() {
            return (this.tablaFirmantes.lista.length - this.tablaFirmantes.lista.filter(f => f.firmo).length);
        },
        mostrarOpcionGuardarSolicitud() {
            return (
                (this.formularioSolicitud.esDocumentoDeBaseDeDatos 
                    ? this.campoEsValido(this.formularioSolicitud.tablaDocumentosSIOP.lista.find(d => d.seleccionado))
                    : this.campoEsValido(this.formularioSolicitud.archivo)) && 
                this.formularioSolicitud.tablaUsuarios.lista.some(u => u.seleccionado) && 
                this.campoEsValido(this.formularioSolicitud.descripcion)
            );
        },
        getNumeroDeFirmantesSolcitud() {
            return(
                this.formularioSolicitud.tablaUsuarios.lista.filter(u => u.seleccionado).length
            );
        },
        getNumeroDePendientes() {
            return (
                this.pendientesDeFirmar.lista.filter(s => !s.usuarioYaAgregoSuFirma).length
            );
        },
        getNumeroDePendientesParaFirmar() {
            return (
                this.pendientesDeFirmar.lista.filter(p => p.seleccionado).length
            );
        },
        mostrarOpcionFirmar() {
            return this.pendientesDeFirmar.lista.some(p => p.seleccionado)
        },
        getNumeroDeDocumentosAFirmar() {
            return (
                this.campoEsValido(this.pendientesDeFirmar.lista.filter(p => p.seleccionado))
                    ? this.pendientesDeFirmar.lista.filter(p => p.seleccionado).length
                    : 1
            );
        }
    },
    async mounted() {


        this.pendientesDeFirmar.visorDeDocumento.height = `${ ($(window).height() - 160 ) }px`;
        this.formularioSolicitud.visorDeDocumento.height = `${ ($(window).height() - 230 ) }px`;
        window.operateEvents = {
            'click .btn-listado-firmantes-accion-VFDD': (e, value, row, index) => { 
                this.cargarInformacionFirmantesDeSolicitudes({ multifirma: row, conLoading: true });
            },
            'click .btn-verDocumento-VFDD': (e, value, row, index) => { 
                this.mostrarDocumentoDeSolicitud({ solicitud: row });
            },
            'click .btn-verDocumentoFirmado-VFDD': (e, value, row, index) => { 
                this.mostrarDocumentoDeSolicitud({ solicitud: row });
            },
            'click .btn-accion-docuemntos-siop': (e, value, row, index) => { 
                this.mostrarDocumentoDeSIOP({ documento: row });
            },
            'click .accion-remover-usr-seleccionados': (e, value, row, index) => { 
                this.removerUsrSeleccionadoDesdeSeccion({ usuario: row });
            }
        };

        /* console.log('VALOR:KAJUR::', KJUR.asn1) */
    },
    async created() {
        comun.SeEstaCargandoInformacion(true);
        await Promise.resolve(this.cargarInformacionDeSolicitudes({ conLoading: false }));
        await Promise.resolve(this.cargarInformacionDeFirmantes());
        comun.SeEstaCargandoInformacion(false);
    }
}
</script>
<style scoped>
.btn-save-solicitud {
    padding: 0.475rem 3rem !important;
    font-size: 1.1rem !important;
    line-height: 1.5 !important;
}

@media (max-width: 1240px) {
    .tabla-firma-multiple-VFDD table {
        table-layout: auto !important;
        word-wrap:normal !important; 
    }

    .paso-principal-creacion-solicitud .form-control {
        height: calc(1em + .375rem + 2px);
        padding: .5em 1em 2.3em 1em !important;
        font-size: .70rem !important;
        border-radius: .2rem;
    }

    .paso-principal-creacion-solicitud  textarea {
        height: 5em !important;
    }

    .paso-principal-creacion-solicitud h6, .paso-principal-creacion-solicitud i {
        font-size: 0.77em !important;
    }

    h5 {
        font-size: 1em !important;
    }
}

@media (max-width: 600px) {
    #seccion-principal-firma-multiple {
        font-size: 10px !important;
    }
}

@media (max-width: 800px) {
    #seccion-principal-firma-multiple {
        font-size: 12px !important;
    }
}

/* ========== FUENTES ============== */
#seccion-principal-firma-multiple {
    font-size: 1rem;
}

.hover-texto:hover {
    font-weight: bold;
    text-decoration: underline;
}

/* ========== TITULOS ============== */
#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

.btn-encabezado {
    color: #fff;
    background-color: #006474;
    border-color: #006474;
}

.btn-encabezado:hover {
    color: #fff;
    background-color: #01444e;
    border-color: #01444e;
}

.btn-firmantes-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-firmantes-VFDD:hover {
    color: #fff;
    background-color: #0f1113;
    border-color: #0f1113;
}

.btn-verDocumento-VFDD {
    color: #212529;
    background-color: rgb(223, 223, 223);
    border-color: #212529;
}

.btn-verDocumento-VFDD:hover {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-verDocumentoFirmado-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-verDocumentoFirmado-VFDD:hover {
    color: #fff;
    background-color: #0f1113;
    border-color: #0f1113;
}
/* ========== SECCIONES ============== */
#seccion-principal-firma-multiple .card-body {
    background-color: #323335;
}

#seccion-principal-firma-multiple .card {
    border: 1px solid rgb(129, 129, 129) !important;
}

#seccion-principal-firma-multiple .card-header {
    background-color: rgb(80, 80, 80);
}

#paso-creacion-solicitud hr {
    border: 1px solid rgb(39, 39, 39);
}

#modal-mostrar-seccion-firmar-VFDD .modal-lg {
    max-width: 30% !important;
}

#modal-mostrar-seccion-firmar-VFDD .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-mostrar-seccion-firmar-VFDD .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

#modal-firma-documento-VFDD .btn-primary {
    background-color: black;
}

#modal-firma-documento-VFDD .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-firma-documento-VFDD .modal-lg {
    max-width: 40% !important;
}

#modal-firma-documento-VFDD .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-creacion-solicitud-VFDD .btn-primary {
    background-color: black;
}

#modal-creacion-solicitud-VFDD .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-creacion-solicitud-VFDD .modal-lg {
    max-width: 60% !important;
}

#modal-creacion-solicitud-VFDD .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-documento-solicitud-VFDD .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-documento-solicitud-VFDD .modal-lg {
    max-width: 80% !important;
}

#modal-documento-solicitud-VFDD .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-informacion-firmantes-VFDD .btn-primary {
    background-color: black;
}

#modal-informacion-firmantes-VFDD .modal-footer {
    border-top: 2px solid rgb(27, 27, 27);
}

#modal-informacion-firmantes-VFDD .modal-lg {
    max-width: 50% !important;
}

#modal-informacion-firmantes-VFDD .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

.paso-formulario-modal {
    padding: 1em 1em 1em 1em; 
    border: 1.8px solid rgb(39, 39, 39);
}

#modal-firma-documento-VFDD .alert-danger {
    border: 1px solid #7e0e19;
    background-color: #a07b7f;
    padding-bottom: 0;
}



</style>
<style>
@media (max-width: 1240px) {
    .tabla-firma-multiple-VFDD td, .tabla-firma-multiple-VFDD th {
        font-size: 0.77em !important;
    }

    .tabla-firma-multiple-VFDD .form-control {
        width: 10em !important;
    }
}

.filtros-imp-text-VFDD .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
    border: none;
}

.filtros-imp-text-VFDD .form-control {
    border: none !important;
}

.estatus-firmado-VFDD {
    border: 1px solid rgb(3, 109, 3);
    background-color: rgb(88, 110, 88);
    color: white;
    border-radius: 4px;
    width: max-content;
    padding: 0.2em 1em 0.2em 1em;
}

.estatus-sin-firma-VFDD {
    border: 1px solid rgb(126, 2, 2);
    background-color: rgb(175, 46, 29);
    color: white;
    border-radius: 4px;
    width: max-content;
    padding: 0.2em 1em 0.2em 1em;
}

.btn-firmantes-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-firmantes-VFDD:hover {
    color: #fff;
    background-color: #0f1113;
    border-color: #0f1113;
}

.btn-verDocumento-VFDD {
    color: #212529;
    background-color: rgb(223, 223, 223);
    border-color: #212529;
}

.btn-verDocumento-VFDD:hover {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-verDocumentoFirmado-VFDD {
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}

.btn-verDocumentoFirmado-VFDD:hover {
    color: #fff;
    background-color: #0f1113;
    border-color: #0f1113;
}

.tabla-firma-multiple-VFDD .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-firma-multiple-VFDD .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-firma-multiple-VFDD td {
    background-color: rgb(223, 223, 223);
    vertical-align: middle;
    font-weight: bold;
}

.tabla-firma-multiple-VFDD .borderless td, .tabla-firma-multiple-VFDD .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-firma-multiple-VFDD .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}


.tabla-firma-multiple-VFDD .btn-edt-cont-intr:hover, .tabla-firma-multiple-VFDD .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.tabla-firma-multiple-VFDD .btn-rmv-cont-intr:hover, .tabla-firma-multiple-VFDD .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.tabla-firma-multiple-VFDD table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word; 
}

.tabla-firma-multiple-VFDD .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-firma-multiple-VFDD .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-firma-multiple-VFDD .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-firma-multiple-VFDD > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 
.upload-container {
    position: relative;   
    background: #f1f1f1;
    /* outline: 2px dashed #92b0b3; */
     border: 1px solid #92b0b3; 
    width: 100%;
    color:#009bca;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: 1em;
}
.area-documento{
   
    outline:  rgb(5, 168, 5) solid;
    border-radius: 8px;
    padding-left: .5em;
}
.area-documento:hover{
    background-color: rgb(247, 176, 176);
}
.upload-container input {
    /* border: 1px solid #92b0b3; */
    background: #f1f1f1;
    outline: 2px dashed #92b0b3 !important; 
    outline-offset: -10px;
    padding: 30px 0px 100px 20px;
    text-align: center !important;
    width: 100%;
    height: 6em !important;
    color:transparent;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: 1em;
}
 
.upload-container input:hover {
    background: #ddd;
     
}
 
.upload-container:before {
    position: absolute;
    bottom: 50px;
    left: 245px;
    color: #3f8188;
    font-weight: 900;
}
 

</style>


// WEBPACK FOOTER //
// src/components/FirmaElectronica/FirmaMultiple/CFirmaMultiple.vue